import { render, staticRenderFns } from "./PwdSetting.vue?vue&type=template&id=8ddf9042&scoped=true&"
import script from "./PwdSetting.vue?vue&type=script&lang=js&"
export * from "./PwdSetting.vue?vue&type=script&lang=js&"
import style0 from "./PwdSetting.vue?vue&type=style&index=0&id=8ddf9042&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ddf9042",
  null
  
)

export default component.exports